import { render, staticRenderFns } from "./bussinessSetting.vue?vue&type=template&id=244816c2&scoped=true"
import script from "./bussinessSetting.vue?vue&type=script&lang=js"
export * from "./bussinessSetting.vue?vue&type=script&lang=js"
import style0 from "./bussinessSetting.vue?vue&type=style&index=0&id=244816c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244816c2",
  null
  
)

export default component.exports